import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="google-map"
//
// The interactive Google map is NOT loaded on page render — it stays a
// lightweight CSS placeholder with a "Show map" button until the user clicks
// it (reveal). This avoids a billable Maps load on every event-page view when
// most visitors never look at the map.
export default class extends Controller {
  static targets = ['myMap', 'placeholder'];
  static values = { lat: Number, lng: Number };

  reveal() {
    const lat = this.latValue;
    const lng = this.lngValue;
    if (lat == null || lng == null || Number.isNaN(lat) || Number.isNaN(lng)) return;

    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none");
    if (this.hasMyMapTarget) this.myMapTarget.classList.remove("d-none");

    this.initMap(lat, lng);
  }

  async initMap(lat, lng) {
    const position = { lat: lat, lng: lng };
    const mapId = this.myMapTarget;

    // Wait for Google Maps API to load
    await this.waitForGoogleMaps();

    const { Map } = await google.maps.importLibrary("maps");
    const map = new Map(mapId, {
      center: position,
      zoom: 12,
      mapTypeControl: false,
      streetViewControl: false,
    });

    this.addSingleMarker(position, map);
  }

  waitForGoogleMaps() {
    return new Promise((resolve) => {
      if (typeof google !== 'undefined' && google.maps) {
        resolve();
      } else {
        const checkGoogleMaps = () => {
          if (typeof google !== 'undefined' && google.maps) {
            resolve();
          } else {
            setTimeout(checkGoogleMaps, 100);
          }
        };
        checkGoogleMaps();
      }
    });
  }

  addSingleMarker(position, map) {
    new google.maps.Marker({
      position,
      map,
      title: "Event Location",
      animation: google.maps.Animation.BOUNCE,
    });
  }
}
